<!-- footer -->
<template>
  <div id='footerPage'>
    <div class="footer-top">
      <div class="footer-top-content">
        <div class="info-text">
          <p class="info-tip">成就每一个教育理想</p>
        </div>
        <button class="special-btn" @click="openService">专人服务</button>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="footer-bottom-content-item">
          <div class="nav">
            <div class="nav-item" v-for="(item, index) in currentList" :key="index">
              <span class="nav-name" @click="item.children&&item.children.length > 0? '': goPath(item.path)">{{item.name}}</span>
              <div class="sub-box" v-if="item.children&&item.children.length > 0">
                <div class="sub-nav-item" v-for="(temp, index) in item.children" :key=index @click="goPath(temp.path)">{{temp.name}}</div>
              </div>
            </div>
          </div>
          <p class="copyright">Copyright © ️2020  好未来版权所有  北京乐读乐考教育科技有限公司</p>
          <p class="backup" @click="goDetail">京ICP备18011062号-1 晋公网安备14102102000119号</p>
        </div>
        <div class="footer-bottom-content-item pdldistance">
          <div class="introduce-box">
            <div class="info-li" v-for="(item, index) in footerText" :key="index">
              <span class="title" v-html="item.title">{{item.title}}</span>
              <span v-if="item.isTel" class="tel">{{item.tel}}</span>
              <span v-html="item.content" :class="item.extra ? 'hasExtra' : 'content'"></span>
              <span v-if="item.extra" class="extra">{{item.extra}}</span>
            </div>
          </div>
          <div class="qrcode-box">
              <div class="qrcode-img-box">
                <img class="qrcodeImg" src='https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/ms-qrcode.png' />
              </div>
              <div class="qrcode-des">
                <p>扫描二维码</p>
                <p>关注未来魔法校</p>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="footer-fun-com">
      <div class="footer-fun">
        <img class="footer-fun-logo" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-fun-logo.png">
      <div class="common-fun">
        <callCenter></callCenter>
        <img class="footer-fun-img" @click="openService" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-service.png">
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { footerNavList } from '@/const'
import callCenter from '@/components/callcenter'
export default {
  props: {
    toTop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      navList: footerNavList,
      noTopRouter: '/application',
      topTitle: '‘成就每一个教育理想，',
      footerText: [
        { title: '咨询电话:', content: ' 转 8009', isTel: true, tel: '010-86393015', extra: '（服务时间：周一至周五 09:00 - 20:00）' },
        { title: '邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱:', content: 'ms.hezuo@tal.com' },
        { title: '地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址:', content: '北京市海淀区远中悦来大厦B座2层' },
        { title: '收款信息:', content: '收款账户 北京学而思网络科技有限公司<br>开户银行 广发银行北京上地支行<br>开户账号 137281512010000397' }
        // { title: '', content: '开户银行 广发银行北京上地支行' },
        // { title: '', content: '开户账号 137281512010000397' }
      ],
      footerBottom: ['Copyright © ️2018 好未来版权所有', '北京乐读乐考教育科技有限公司', '京ICP备18011062号-1'],
      backSeconds: 300
    }
  },
  components: { callCenter },
  computed: {
    currentList () {
      return this.navList.filter((item) => { return item.path !== '/' && item.path !== '/download' })
    }
  },
  methods: {
    goPath (path) {
      console.log('gopath', path)
      this.$router.push(path)
    },
    backTop () {
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      let step = distance / this.backSeconds
      let backTopInterval = setInterval(function () {
        distance = document.documentElement.scrollTop || document.body.scrollTop
        if (distance > 0) {
          document.documentElement.scrollTop -= step
          document.body.scrollTop -= step
        } else {
          clearInterval(backTopInterval)
        }
      }, 1)
    },
    goDetail () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14102102000119')
    },
    openService () {
      this.$EventBus.$emit('open')
    }
  }
}
</script>
<style scoped lang='scss'>
#footerPage {
    position: relative;
    font-family:PingFang SC;
    .footer-top{
      width: 100%;
      background: #1a1928;
      .footer-top-content{
        width: 1280px;
        height:321px;
        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-top.jpg') no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        padding-top: 73px;
        .info-text{
          margin: 0 auto;
          width: 467px;
          height: 75px;
          line-height: 75px;
          font-size:40px;
          font-family:PingFangSC-Regular;
          color:#ffffff;
          background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/footer-top-semi.png');
          background-size: 100% 100%;
        }
        .special-btn{
          margin-top: 54px;
          width:321px;
          background:#FB594A;
          box-shadow:0px 5px 5px 0px rgba(0, 0, 0, 0.1);
          border-radius:5px;
          line-height: 60px;
          font-size:22px;
          font-family:PingFangSC-Regular;
          color:#ffffff;
          border: 0;
          cursor: pointer;
          &:active{
              background: #f05648;
          }
        }
      }
    }
    .footer-bottom {
      width: 100%;
      height: 633px;
      padding: 75px 82px 82px;
      color: #ffffff;
      background: #1B1D22;
      position: relative;
      .footer-bottom-content{
        width: $main-width;
        margin: 0 auto;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .pdldistance{
          padding-left: 70px;
        }
        .footer-bottom-content-item{
          width: 50%;
          text-align: left;
          .nav{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;
            padding-top: 9px;
            .nav-item{
              position: relative;
              font-weight: bold;
              .nav-name{
                font-size:16px;
                font-weight:400;
                line-height:16px;
                margin-bottom: 36px;
                display: inline-block;
              }
              .sub-box{
                .sub-nav-item{
                  white-space: nowrap;
                  font-size:14px;
                  font-weight:400;
                  color:rgba(255,255,255,0.4);
                  line-height:14px;
                  margin-bottom: 20px;
                  cursor: pointer;
                  &:last-of-type{
                    margin-bottom: 0px;
                  }
                }
                .sub-nav-item:hover{
                    color: #ffffff;
                }
              }
            }
            .nav-item + .nav-item {
              margin-left: 125px;
            }
          }
          .copyright{
            margin-top: 180px;
            font-size:14px;
            font-weight:400;
            color: rgba(255, 255, 255, 0.4);
          }
          .backup{
            margin-top: 5px;
            font-size:14px;
            font-weight:400;
            color: rgba(255, 255, 255, 0.4);
            cursor: pointer;
          }
        }
        .introduce-box{
          padding-top: 2px;
          .info-li {
            display: flex;
            align-items: baseline;
            line-height: 36px;
            font-size: 14px;
            font-weight: 400;
            .tel{
              text-decoration: none;
              color: #939395;
            }
            .title{
              display: inline-block;
              margin-right: 16px;
            }
            .content{
              flex: 1;
              color: #939395;
            }
            .hasExtra{
              color: #939395;
              margin-right: 20px;
            }
            .extra {
              color: #939395;
            }
          }
        }
        .qrcode-box{
          margin-top: 52px;
          display: flex;
          justify-content: flex-start;
          align-items:flex-end;
          .qrcode-img-box{
            width: 150px;
            height: 150px;
            background:rgba(255,255,255,0.1);
          }
          .qrcodeImg{
            width: 100px;
            height: 100px;
            margin: 25px;
          }
          .qrcode-des{
            font-size: 14px;
            line-height: 14px;
            font-weight: 400;
            margin-left: 16px;
            position: relative;
            p{
              margin-bottom: 5px;
            }
          }
        }
      }
    }
    .footer-fun-com{
      width: 100%;
      background:rgba(0,0,0,0.85);
      position: fixed;
      bottom: 0px;
      left: 0px;
      z-index: 1000;
      .footer-fun{
        width: $main-width;
        margin: 0 auto;
        height:70px;
        box-shadow:0px -10px 15px 0px rgba(0, 0, 0, 0.05);
        padding: 0px 87px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .footer-fun-logo{
          width: 155px;
          height: 43px;
        }
        .common-fun{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .footer-fun-img{
            width: 145px;
            height: 50px;
            margin-top: 10px;
            cursor: pointer;
            &:last-of-type{
              margin-right: 0px;
            }
          }
        }
      }
    }
  }
</style>
